export const FAQ_CONTENT = `
faqContent {
  ... on faqContent_Entry {
    id
    title
    items {
      ... on faqItem_Entry {
        question
        answer {
          html
        }
      }
    }
  }
}
`

export const FAQ = `
...on faq_Entry {
  id
  typeHandle

  heading {
    html
  }
  description
  
  ${ FAQ_CONTENT }
}
`

export const FAQ_CENTERED = `
...on faqCentered_Entry {
  id
  typeHandle

  heading {
    html
  }
  backgroundColor

  ${ FAQ_CONTENT }
}
`

export const FAQ_DELIGHT = `
...on faqDelight_Entry {
  id
  typeHandle
  anchorId

  heading {
    html
  }

  description

  ${ FAQ_CONTENT }
}
`